<template>
    <div> 
      <h1>Alibaba Dragonwell8 Standard Edition Statement of Java SE Compatibility</h1>
      <v-row justify="center">
        <v-col cols="1"></v-col>
        <v-col cols="10" class="content-text">
          <p>All Alibaba Dragonwell(JDK 8) standard edition binaries available from <a target="_blank" href="https://github.com/alibaba/dragonwell8/releases">https://github.com/alibaba/dragonwell8/releases</a> have passed all requirements of the then-current Java SE 8 Compatibility test suite(JCK tests), and are compliant and compatible implementations.</p>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <div class="footer-location">
        <Footer></Footer>
      </div>
    </div>
</template>
<script>
  import Footer from "./Footer";
  export default {
      components: {
        Footer
      },
      data () {
          return {
            msg: ''
          }
      }
  }

</script>

<style>
h1 {
  margin-top: 65px;
  text-align: center;
}
.content-text p {
  color: #000;
  font-size: 18px;
}
.footer-location {
  position: fixed;
  bottom: 0px;
}
</style>